import React, { useState, useEffect } from 'react';

import { getLinkedShop } from '../modules/NetworkFunction';

const ShopModeContext = React.createContext({
  shopMode: '',
  linkedShop: '',
  setShopMode: () => {},
});

export const ShopModeContextProvider = ({ auth, children }) => {
  const [shopMode, setShopMode] = useState(localStorage.getItem('shopMode'));
  const [linkedShop, setLinkedShop] = useState('');

  useEffect(() => {
    getLinkedShop(
      null,
      (data) => {
        setLinkedShop(data);
        setShopMode((prev) => {
          if (prev === 'makeshop' && data !== 'cafe24') {
            return prev;
          }
          if (prev === 'cafe24' && data !== 'makeshop') {
            return prev;
          }

          return data === 'makeshop' ? 'makeshop' : 'cafe24';
        });
      },
      (err) => {
        console.log(err);
      },
      auth
    );
  }, [auth]);

  useEffect(() => {
    localStorage.setItem('shopMode', shopMode);
  }, [shopMode]);

  return (
    <ShopModeContext.Provider value={{ shopMode, setShopMode, linkedShop }}>
      {children}
    </ShopModeContext.Provider>
  );
};

export default ShopModeContext;
